export default (state = false, action) => {
  switch (action.type) {
    case 'POST_SALES_ORDER':
      return { ...state, ...action.payload } || false
    default:
      return state
  }
} 